import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import { red } from '@mui/material/colors';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import ModeEditOutlineRoundedIcon from '@mui/icons-material/ModeEditOutlineRounded';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import Modal from "@mui/material/Modal";
import "../Dashboard.css";
import "../Components/SideMenu.css";
import SideMenu from "../Components/SideMenu";
import "mdb-ui-kit/css/mdb.min.css";
import AddBranchForm from "./AddBranchForm";

import CircularIndeterminate from '../../GeneralComponents/CirularProgress'
import StyledDataGrid from '../../GeneralComponents/StyledDataGrid'
import "../../../../assets/css/DG.css"
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';

import { useGlobalContext } from '../../../../context'
import UpdateBranchForm from "./Branches/UpdateBranchForm";
import ViewBranch from "./Branches/ViewBranch";
import axios from "axios";
import ApiSettings from "../../../../Settings/ApiSettings.json";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import BranchRoleForm from "./Branches/BranchRoleForm";
import swal from 'sweetalert'
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
};

export default function AddBranch(props) {

  const [pageSize, setPageSize] = useState(5);
  const [pageNumber, setpageNumber] = useState(1);
  const [branchesTotal, setBranchesTotal] = useState(0)
  const [branchesNumberOfPages, setBranchesNumberOfPages] = useState(0)
  const [showBoxOfEditForm, setshowBoxOfEditForm] = useState(false);
  const [showBoxOfBranchRoleForm, setShowBoxOfBranchRoleForm] = useState(false)
  const [showBoxOfViewForm, setshowBoxOfViewForm] = useState(false);
  const [selectedObject, setSelectedObject] = useState(null);
  const { loading, branches, fetchData } = useGlobalContext()
  const [reload, setReload] = useState(false)

  const [columns] = useState([
    { field: 'id', headerName: 'ت', flex: .1 },

    { field: 'name', headerName: 'الاسم', flex: 1 },

    {
      field: 'actions', flex: 0.5,
      headerName: 'الادوات',
      renderCell: (rows) => (
        <strong>


          <IconButton
            style={{ marginLeft: 15 }}
            aria-label="عرض"
            size="small"
            onClick={() => {
              viewObject(rows.row)
            }}
          >
            <Tooltip title="View">
              <RemoveRedEyeRoundedIcon color="primary" />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ marginLeft: 15 }}
            aria-label="تعديل"
            size="small"
            onClick={() => {
              updateObject(rows.row)

            }}
          >
            <Tooltip title="Edit">
              <ModeEditOutlineRoundedIcon style={{ fill: "#deb12c" }} />
            </Tooltip>
          </IconButton>
          <IconButton
            style={{ marginLeft: 15 }}
            aria-label="المسميات الوظيفية"
            size="small"
            onClick={() => {
              updateBranchRole(rows.row)

            }}
          >
            <Tooltip title="المسميات الوظيفية">
              <FactCheckIcon style={{ fill: "#59776E" }} />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ marginLeft: 20 }}
            aria-label="مسح"
            size="small"
            onClick={() => {
              softDelete(rows.row)
            }}
          >
            <Tooltip title="Delete">
              <DeleteRoundedIcon sx={{ color: red[500] }} />
            </Tooltip>
          </IconButton>
        </strong>
      ),
    },
  ]);

  const [rows, setRow] = useState([])
  const handlePageChange = (newPage) => {
    setpageNumber(newPage + 1)
  }
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });

  const updateObject = async (object) => {
    setSelectedObject(object)

    setshowBoxOfEditForm(true)
  };
  const updateBranchRole = (object) => { 
    setSelectedObject(object)
    setShowBoxOfBranchRoleForm(true)
   }
  const viewObject = async (object) => {
    setSelectedObject(object)
    setshowBoxOfViewForm(true)
  };
  const advanceSearch = () => {

    fetchData('BRANCHES', 'branches', {
      page: pageNumber,
      page_size: pageSize,
    });
  }
  
  useEffect(() => {

    advanceSearch()

  }, [pageSize, pageNumber, reload])
  //Reformatting branches object once branches are loaded
  useEffect(() => {
    console.log("hi");
    console.log(branches);
    if (branches && branches.data && branches.data.length > 0) {

      const reformatData = branches.data.map((rowBranch) => {
        return {
          ...rowBranch

        }
      })
      console.log(reformatData);
      setRow(reformatData);
      setBranchesTotal(branches.total)
      setBranchesNumberOfPages(branches.last_page)
    }
  }, [branches])

  const setReloadData = () => {
    setReload(!reload)
  }

  //here we will sent request with data to save it in our database.
  const softDelete = async (object) => {

    // setLoading(true);
    swal({
      title: "هل انت متأكد?",
      text: "بمجرد حذفك للعنصر لن يكون بامكانك استاعدته!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then(async(willDelete) => {
      if (willDelete) {
      let data = null;
      try {
        data = await axios({
          method: "delete",
          url: ApiSettings.apiUrl + "/branches/" + object.id,

          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-localization": 'ar'
          },
        });

        console.log("delete", data);
        if (data) {
          if (data.data.status == 200) {
            // setLoading(false);

            setsnackBar({
              ...snackBar,
              message: data.data.message,
              severity: "success",
              open: true,
            });
            setReloadData()
          } else if (data.data.status == 402) {
            //   alert(data.data.data.name);
            setsnackBar({
              ...snackBar,
              message: data.data.data.name,
              severity: "warning",
              open: true,
            });
          } else {
            //   alert(data.data.message);
            setsnackBar({
              ...snackBar,
              message: data.data.message,
              severity: "warning",
              open: true,
            });
          }
          // setLoading(false);
        }
      } catch (err) {
        //   alert(err.message);
        setsnackBar({
          ...snackBar,
          message: err.message,
          severity: "error",
          open: true,
        });
        // setLoading(false);
      }
    }
  })
  };
  return (
    <div className="Dashboard_MOF px-0 mx-0">

      <div className="container-fluid h-100 w-100 mx-0 px-0">
        <div className="row rowContainer mx-0">
          <div className="col-md-12 col-xl-12 height-100 w-100 d-flex flex-column justify-content-center align-items-end  paddingForm">
            <AddBranchForm inactive={props.inactive} setReloadData={setReloadData} />

            <div
              className={`FormContainer  ${props.inactive === false ? "activeSideMenu" : ""
                }`}
              style={{ height: 'calc(100% - 9em)', borderRadius: 10 }}>

              <StyledDataGrid
                rows={rows}
                columns={columns}
                rowCount={branches?.total ? branches?.total : 0}
                pageSize={pageSize}
                page={pageNumber - 1}
                onPageSizeChange={(newPageSize) => {
                  setPageSize(newPageSize)
                }}

                components={{
                  Footer: () => null,
                }}
                rowsPerPageOptions={[5, 10, 20]}
                // pagination
                paginationMode="server"
                onPageChange={(params) => {
                  handlePageChange(params)
                }}
              />
              <Box width="45%" m="auto" sx={{ direction: 'ltr' }}>
                <Pagination
                  color="primary"
                  size="large"
                  count={branchesNumberOfPages}
                  page={pageNumber}
                  showFirstButton
                  showLastButton
                  onChange={(e, p) => {
                    setpageNumber(p)
                  }}
                />
              </Box>

              <div style={{ width: '50%', position: 'absolute', top: '100px', margin: '0 auto', left: '50%', top: '50%' }}>
                {loading && (
                  <CircularIndeterminate />
                )}
              </div>
            </div>
          </div>
          
        </div>
      </div>
      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={()=>{setsnackBar({ ...snackBar, open: false })}}
        anchorOrigin={{ vertical:snackBar.vertical, horizontal:snackBar.horizontal }}
      >
        <Alert
          onClose={()=>{setsnackBar({ ...snackBar, open: false })}}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>
      <Modal
        keepMounted
        open={showBoxOfEditForm || showBoxOfViewForm || showBoxOfBranchRoleForm}
        onClose={() => {
          setshowBoxOfEditForm(false);
          setshowBoxOfViewForm(false);
          setShowBoxOfBranchRoleForm(false);
        }}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{
            border: "none",
            outline: "none",
            borderRadius: "10px",
            overflow: "scroll",
          }}
          className="modalCroupsCarrier"
        >
          {selectedObject && showBoxOfEditForm &&
            <UpdateBranchForm object={selectedObject} setReloadData={setReloadData} />}
          {selectedObject && showBoxOfBranchRoleForm &&
            <BranchRoleForm object={selectedObject} setReloadData={setReloadData} />}
          {selectedObject && showBoxOfViewForm &&

            <ViewBranch object={selectedObject} />}
        </Box>
      </Modal>
    </div>
  );
}
